import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../hooks'
import { FormikField } from '../../../../Formik'
import { InputField } from '../../../../Input'
import {
  CONTRACT_FORM_CONTRACT_ID_MAX_LENGTH,
  CONTRACT_FORM_FIELD_NAME_PURCHASE_CONTRACT_NUMBER,
} from '../../../Contract.constants'

function SecondContractIdField() {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen()

  return (
    <FormikField
      hasCounter
      Component={InputField}
      borderless={!isMobileScreenSize}
      fieldComponentProps={{
        label: `${t('Flat.SecondContractIdLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      inline={isMobileScreenSize}
      maxLength={CONTRACT_FORM_CONTRACT_ID_MAX_LENGTH}
      name={CONTRACT_FORM_FIELD_NAME_PURCHASE_CONTRACT_NUMBER}
      placeholder={t('Flat.SecondContractIdPlaceholderKey')}
    />
  )
}

export default SecondContractIdField
